<template>
  <SectionFrame v-if="items.length || inStudio" :section="section" :index="index" :heading="heading" label="Numbers" :center="layout === 'band'">
    <dl v-if="items.length" :class="layout === 'cards' ? 's2-num-cards' : 's2-num-band'" class="mo-stagger" :style="{'--s2-n': Math.min(items.length, 4)}">
      <div v-for="(n, i) in items" :key="i" :class="layout === 'cards' ? 't-card' : ''">
        <dt class="s2-hp">{{ n.label || n.value }}</dt>
        <dd class="s2-num">
          <template v-if="section.countUp !== false && n.number">{{ n.prefix }}<span class="mo-count" :data-to="n.number" :data-suffix="n.suffix">{{ n.value.slice(n.prefix.length) }}</span></template>
          <span v-else>{{ n.value }}</span>
        </dd>
        <dd class="s2-num-label s2-muted">{{ n.label }}</dd>
      </div>
    </dl>
    <StudioGap v-else>Add the figures you're proud of (years trading, jobs done). Draksy won't guess them.</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, numberItems} from "@/utils/sectionLogic.js";
import {studioMode} from "@/classes/previewBridge.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}, data: {type: Object, default: () => ({})}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["band", "cards"]));
const heading = computed(() => props.section.heading ?? "");
const items = computed(() => numberItems(props.section, props.data));
</script>

<style>
.s2-num-band, .s2-num-cards { display: grid; gap: var(--t-gap); grid-template-columns: repeat(var(--s2-n), minmax(0, 1fr)); margin: 0; }
@media (max-width: 760px) { .s2-num-band, .s2-num-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
.s2-num-band { text-align: center; }
.s2-num { margin: 0; font: var(--t-display-weight) clamp(2.2rem, 5vw, 3.6rem) / 1 var(--t-font-display); letter-spacing: var(--t-display-tracking); color: inherit; }
.t-band[data-background="colour"] .s2-num-label { color: inherit; opacity: .85; }
.s2-num-label { margin: .4rem 0 0; }
</style>
